import React from 'react'
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

const AddTabsMenu = ({ menuSelect, setMenuSelect }) => {
  return (
    <div className='addTabs__menu'>
        <div onClick={e => {
            setMenuSelect('comments')
        }}>
            <InsertCommentIcon />
        </div>
        <div onClick={e => {
            setMenuSelect('changes')
        }}>
            <ChangeCircleIcon />
        </div>
    </div>
  )
}

export default AddTabsMenu